const storageKey = "anjabom.synthetic-visit.v1";
let inMemory = false;

/** A boolean test marker only: no token, visitor ID or copied query string. */
export function syntheticVisit(): boolean {
	if (typeof window === "undefined") return false;
	const value = new URLSearchParams(window.location.search).get("synthetic");
	if (value === "1" || value === "0") {
		inMemory = value === "1";
		try {
			if (inMemory) sessionStorage.setItem(storageKey, "1");
			else sessionStorage.removeItem(storageKey);
		} catch { /* Keep the same-tab marker when storage is unavailable. */ }
	} else {
		try { inMemory = sessionStorage.getItem(storageKey) === "1" || inMemory; } catch {}
	}
	return inMemory;
}
